import api from '../api';

export const scheduleApi = api.injectEndpoints({
  endpoints: builder => ({
    getAllScheduleTestCompanies: builder.query({
      query: () => ({
        url: '/api/companies/getallcompanies',
        method: 'GET'
      })
    }),
    scheduleTest: builder.mutation({
      query: body => ({
        url: '/api/schedule/test/schedule',
        method: 'POST',
        body
      }),
      invalidatesTags: ['ScheduleTests']
    }),
    scheduleCustomTest: builder.mutation({
      query: body => ({
        url: '/api/schedule/test/customtest/schedule',
        method: 'POST',
        body
      }),
      invalidatesTags: ['ScheduleTests']
    }),
    fetchAssociatedStudents: builder.query({
      query: () => ({
        url: '/api/students/getAssociatedStudents',
        method: 'GET'
      })
    }),
    fetchScheduleTests: builder.query({
      query: ({ page, size }) => ({
        url: '/api/schedule/test/scheduled/tests',
        method: 'GET',
        params: { page, size }
      }),
      providesTags: ['ScheduleTests']
    }),
    getStudentScheduleTests: builder.query({
      query: ({ userId, page, size }) => ({
        url: '/api/student/scheduled/tests',
        method: 'GET',
        params: { userId, size, page }
      }),
      providesTags: ['StudentScheduleTests']
    }),
    startStudentScheduleTest: builder.mutation({
      query: ({ userId, scheduledTestId }) => ({
        url: '/api/student/scheduled/start/test',
        method: 'POST',
        params: { userId, scheduledTestId }
      }),
      invalidatesTags: ['StudentScheduleTests']
    }),
    saveStudentScheduleTest: builder.mutation({
      query: ({ payload, scheduledUserTestId }) => ({
        url: '/api/student/scheduled/save/test',
        method: 'PUT',
        body: payload,
        params: { scheduledUserTestId }
      })
    }),
    endStudentScheduleTest: builder.mutation({
      query: ({ scheduledUserTestId }) => ({
        url: '/api/student/scheduled/end/test',
        method: 'PUT',
        params: { scheduledUserTestId }
      }),
      invalidatesTags: ['StudentScheduleTests']
    }),
    fetchTestSummary: builder.query({
      query: () => ({
        url: '/api/schedule/test/test/summary',
        method: 'GET'
      }),
      providesTags: ['ScheduleTests']
    }),
    viewScheduleTestStudentDetails: builder.query({
      query: scheduledTestId => ({
        url: '/api/schedule/test/scheduled/test/view/details',
        method: 'GET',
        params: { scheduledTestId }
      })
    }),
    checkDuplicateTestname: builder.query({
      query: testName => ({
        url: '/api/schedule/test/validate/testname',
        method: 'GET',
        params: { testName }
      })
    })
  })
});

export const {
  useGetAllScheduleTestCompaniesQuery,
  useScheduleTestMutation,
  useScheduleCustomTestMutation,
  useFetchAssociatedStudentsQuery,
  useLazyFetchScheduleTestsQuery,
  useLazyGetStudentScheduleTestsQuery,
  useGetStudentScheduleTestsQuery,
  useStartStudentScheduleTestMutation,
  useSaveStudentScheduleTestMutation,
  useEndStudentScheduleTestMutation,
  useFetchTestSummaryQuery,
  useLazyViewScheduleTestStudentDetailsQuery,
  useLazyCheckDuplicateTestnameQuery
} = scheduleApi;
